import React from 'react';
import {_GPY} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';

class ScoreboardPeriods extends  React.Component {

	constructor(props) {
		super(props);
		var periods = new Array(props.periodCount !== undefined ? props.periodCount : 5);
		for( var i=0; i < periods.length ; i++ ) {
			periods[i]  = ""+(i+1);
		}
		this.state = {
			periodsCount: props.periodCount !== undefined ? props.periodCount : 5,
			periods: periods,
	 	};
	}

	componentDidMount() {
	}

	updateDependencies() {

			let view = this.props.scoreboard.state.components[ this.props.scoreboard.getName()+"_button_show_period" ];
			if(view!==undefined&&view.isActive()) {
				view.updateData();
			}
			if ( this.props.getUpdateDependenciesComponents!==undefined ) {
			var l = this.props.getUpdateDependenciesComponents();
			  for(var i=0;i<l.length;i++) {
			    if(this.props.scoreboard.state.components[l[i]]!==undefined && this.props.scoreboard.state.components[l[i]].isActive()) {
				     this.props.scoreboard.state.components[l[i]].updateData();
		 	    }
		  	}
    	}

  }

  render () {
		// const sponsorLogo = this.props.scoreboard.state.currentGame.sponsorLogo!==undefined&&this.props.scoreboard.state.currentGame.sponsorLogo!==''?this.props.scoreboard.state.currentGame.sponsorLogo:"empty.png";

		const my = this.props.scoreboard;
    return (
			<>
			<div className="row">
					<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+my.getName()+'_scoreboard_periods_title')}</strong></div>
					<div className="col-3 p-1">
					<GpyToggleButton title={_GPY.i18n.get('gametype_'+my.getName()+'_scoreboard_message_period')}
						condition={() => {return (this.props.scoreboard.state.currentPeriodIndex>0)}}
						onDeactivate={() => {
							return {visible: false};
						}}
						onActivate={() => {
						return {	visible: true,
							currentSet: my.state.currentPeriodIndex,
							type: "PERIOD",
							message: _GPY.i18n.get('gametype_'+my.getName()+'_scoreboard_message_periods_'+my.state.currentPeriodIndex),
					}}}
					scoreboard={this.props.scoreboard}
					getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
					stateName={this.props.scoreboard.getName()+"_button_show_period"}
					/>
				</div>
					{this.state.periods.map((p,idx)=>{
							return (
								<div key={"period_"+idx} className="col-3 p-1">
								<GpyToggleButton keyCode={""+(idx+1)} title={_GPY.i18n.get('gametype_'+my.getName()+'_scoreboard_message_periods_'+p)}
									onDeactivate={() => {
										this.props.scoreboard.setState({currentPeriodIndex:0,currentPeriodName:""});
										return {visible: false};
									}}
									onActivate={() => {
										{this.state.periods.map((a)=>{
											let comp = my.getComponent(my.getName()+'_button_period_'+a);
											if( a !== p && comp !== undefined && comp.isActive()) {
												comp.onDeactivate();
											}
										})}
										this.props.scoreboard.setState({currentPeriodIndex:(idx+1),currentPeriodName:_GPY.i18n.get('gametype_'+my.getName()+'_scoreboard_message_periods_'+p)},()=>{
												this.updateDependencies();
										});
										if(this.props.onActivate!==undefined) {
											try {
												this.props.onActivate((idx+1));
											} catch {}
										}
									return {
										currentSet: p , visible: true, type:"PERIOD", message: _GPY.i18n.get('gametype_'+my.getName()+'_scoreboard_message_periods_'+p)
								}}}
								scoreboard={this.props.scoreboard}
								getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
								stateName={this.props.scoreboard.getName()+"_button_period_"+p}
								/>
							</div>
						);
					})}
			</div>
		 </>
		);
  }
}
export default ScoreboardPeriods;
